import { render } from "./TextAreaComponent.vue?vue&type=template&id=e1a5a5a8&scoped=true"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js"

import "./TextAreaComponent.vue?vue&type=style&index=0&id=e1a5a5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a5a5a8"]])

export default __exports__